import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import BackupSettingsPage from './BackupSettingsPage.vue';
import BackupHistoryPage from './BackupHistoryPage.vue';
import BackupViewerPage from './BackupViewerPage.vue';

export default {
  routes: [
    // Full-screen viewer — top-level route, not wrapped by SettingsWrapper
    {
      path: frontendURL('accounts/:accountId/settings/backup/view/:backupId'),
      name: 'backup_viewer',
      meta: {
        permissions: ['administrator'],
      },
      component: BackupViewerPage,
    },
    {
      path: frontendURL('accounts/:accountId/settings/backup'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'backup_settings', params: to.params };
          },
        },
        {
          path: 'settings',
          name: 'backup_settings',
          meta: {
            permissions: ['administrator'],
          },
          component: BackupSettingsPage,
        },
        {
          path: 'history',
          name: 'backup_history',
          meta: {
            permissions: ['administrator'],
          },
          component: BackupHistoryPage,
        },
      ],
    },
  ],
};
